export default [
    {
        path: "/loading",
        name: "loading",
        meta: {title: "Loading"},
        component: () => import("../views/loading/loading.vue"),
    },
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: "/home",
        name: "Home",
        meta: {title: "Home"},
        component: () => import("../views/home/index.vue"),
    },
    {
        path: "/homePages",
        name: "homePages",
        meta: {title: "HomePages"},
        component: () => import("../views/homePages/index.vue"),
    },
    {
        path: "/login",
        name: "login",
        meta: {title: "Login"},
        component: () => import("../views/login/login.vue"),
    },
    {
        path: "/userLogin",
        name: "UserLogin",
        meta: {title: "UserLogin"},
        component: () => import("../views/login/userLogin.vue"),
    },
    {
        path: "/register",
        name: "Register",
        meta: {title: "Register"},
        component: () => import("../views/register/register.vue"),
    },
    {
        path: "/enterprise",
        name: "Enterprise",
        meta: {title: "Enterprise"},
        component: () => import("../views/register/enterprise.vue"),
    },
    {
        path: "/personal",
        name: "Personal",
        meta: {title: "Personal"},
        component: () => import("../views/register/personal.vue"),
    },
    {
        path: "/user",
        name: "User",
        meta: {title: "User"},
        component: () => import("../views/register/user.vue"),
    },
    {
        path: "/forgotPassword",
        name: "forgotPassword",
        meta: {title: "Forgot Password"},
        component: () => import("../views/forgotPassword/forgotPassword.vue"),
    },
    {
        path: "/logOff",
        name: "logOff",
        meta: {title: "Log Off"},
        component: () => import("../views/logOff/logOff.vue"),
    },
    {
        path: "/home",
        name: "Home",
        meta: {title: "Home"},
        component: () => import("../views/home/index.vue"),
    },
    {
        path: "/troubleShooting",
        name: "troubleShooting",
        meta: {title: "TroubleShooting"},
        component: () => import("../views/troubleShooting/troubleShooting.vue"),
    },
    {
        path: "/companyInfomation",
        name: "companyInfomation",
        meta: {title: "CompanyInfomation"},
        component: () => import("../views/serviceProvider/companyInfomation.vue"),
    },
    {
        path: "/userManagement",
        name: "userManagement",
        meta: {title: "UserManagement"},
        component: () => import("../views/serviceProvider/userManagement.vue"),
    },
    {
        path: "/approvalManagement",
        name: "ApprovalManagement",
        meta: {title: "ApprovalManagement"},
        component: () => import("../views/serviceProvider/approvalManagement.vue"),
    },
    {
        path: "/tickets",
        name: "tickets",
        meta: {title: "Tickets"},
        component: () => import("../views/tickets/tickets.vue"),
    },
    {
        path: "/homePages",
        name: "homePages",
        meta: {title: "HomePages"},
        component: () => import("../views/homePages/index.vue"),
    },
    {
        path: "/error",
        name: "error",
        meta: {title: "Error"},
        component: () => import("../views/404/error-404.vue"),
    },
    {
        path: "/userInfo",
        name: "userInfo",
        meta: {title: "UserInfo"},
        component: () => import("../views/userInfo/userInfo.vue"),
    },
]